export default {

    data () {
        return {
            emailContext: {},
            emailThread: {},
            loadingEmail: false,
            emailCreateUrl: "/emails/create"
        };
    },

    methods: {
        clearEmailContext () {
            this.emailContext = {};
        },
        createEmail (contactId, documentId, cb) {
            this.createEmailWithUrl(this.emailCreateUrl, contactId, documentId, cb);
        },
        createEmailWithUrl (url, contactId, documentId, cb, requestSubForm) {
            this.emailThread = {};
            this.loadingEmail = true;

            axios.post(url, {
                _method: "POST",
                contact_id: contactId,
                document_id: documentId,
                request_sub_form: requestSubForm
            }).then((response) => {
                this.emailThread = response.data;
                this.loadingEmail = false;
                if (cb) {
                    cb();
                }
            }).catch(errors => {
                this.loadingEmail = false;
                toastr.error(errors.response.data.message);
                this.closeEmailForm();
            });
        },
        draftEmailDeleted () {
            this.emailThread.draft_email = null;
            this.closeEmailForm();
        },
        draftEmailQueued () {
            this.emailThread.draft_email = null;
            this.closeEmailForm();
            this.$emit("clear-context");
        },
        closeEmailForm () {
            this.$emit("close");
        },
        threadForwardCreated (thread) {
            this.emailThread = thread;
        },
        loadThread (threadId) {
            this.$emit("show-thread");

            this.loadingEmail = true;
            axios.get("/emails/thread/" + threadId)
            .then((response) => {
                this.emailThread = response.data;
                if (response.data.quote_requests && response.data.quote_requests[0] != null) {
                    this.emailContext.email_type = "quote-request";
                    this.emailContext.service_provider_id = response.data.quote_requests[0].service_provider_id;
                }
                this.loadingEmail = false;
            })
            .catch(errors => {
                toastr.error(errors);
            });
        }

    }
};
